// Mock data for OOHMA Multimedia recreation.
// NOTE: All content here is MOCKED for the frontend-only build.

export const stats = [
  { value: "30+", label: "Years Experience" },
  { value: "100+", label: "Clients Served" },
  { value: "Pan India", label: "Coverage" },
];

export const marqueeServices = [
  "Smart Bus Shelters",
  "Media Planning & Buying",
  "DOOH School Network",
  "OOH Infrastructure",
  "Digital Publisher Solutions",
  "Festival Branding",
  "Retail Activation",
];

export const brands = [
  "Hindustan Unilever",
  "MakeMyTrip",
  "McDonald's",
  "Maruti Suzuki",
  "Amazon",
  "Dalmia Bharat",
  "V-Mart",
  "Raheja Developers",
  "Chhattisgarh Govt",
  "Ramalaya",
];

export const whatWeDo = [
  {
    no: "01",
    icon: "Building2",
    title: "Smart Bus Shelters",
    desc: "Urban infrastructure designed for utility, sustainability, and high-impact advertising — built to integrate seamlessly into city environments.",
  },
  {
    no: "02",
    icon: "MapPin",
    title: "Transit & Outdoor Media",
    desc: "Strategically deployed formats across high-footfall locations, delivering consistent visibility where audiences naturally move.",
  },
  {
    no: "03",
    icon: "Wrench",
    title: "Custom Fabrication",
    desc: "End-to-end design and build of bespoke media structures — engineered for durability, scale, and real-world conditions.",
  },
  {
    no: "04",
    icon: "Coins",
    title: "Media Monetisation",
    desc: "Maximising long-term value of assets through strategic brand partnerships, ad placements, and revenue optimisation.",
  },
  {
    no: "05",
    icon: "MonitorPlay",
    title: "DOOH School Network",
    desc: "India's largest in-class DOOH network — 22,000 screens across 20,000 schools reaching 2 crore+ children monthly.",
  },
  {
    no: "06",
    icon: "Cpu",
    title: "AI Publisher Solutions",
    desc: "InsurAds-powered AI tool for digital publishers — driving 30-40% revenue growth through intelligent ad optimisation.",
  },
];

export const services = [
  {
    no: "01",
    icon: "Building2",
    title: "Smart Bus Shelters",
    desc: "We design, fabricate, and install solar-powered smart bus shelters under CSR mandates. Each shelter features real-time information boards, USB charging, and 100% recyclable materials — doubling as premium advertising assets with 9-year brand exclusivity.",
  },
  {
    no: "02",
    icon: "Target",
    title: "Media Planning & Buying",
    desc: "With 30+ years of industry experience and deep vendor relationships, we plan and buy across uni-poles, billboards, bus shelters, LED screens, and wall paintings. Pan-India reach. Premium locations. Cost-effective CPM.",
  },
  {
    no: "03",
    icon: "Wrench",
    title: "Custom Fabrication",
    desc: "Bespoke media structure design and build — from heritage-themed bus shelters for MakeMyTrip in Mathura to large-format iron-frame display boards across Chhattisgarh. Eco-friendly, GPS-documented, field-proven.",
  },
  {
    no: "04",
    icon: "MonitorPlay",
    title: "DOOH School Network",
    desc: "22,000 in-class screens across 20,000 schools via Routes2Roots NGO, in collaboration with the Ministry of Culture. Captive audience of 8–18 year olds. Confirmed 2 Crore monthly reach. Lowest cost-per-reach in any media format in India.",
  },
  {
    no: "05",
    icon: "Cpu",
    title: "AI Publisher Solutions (InsurAds)",
    desc: "Exclusive India partner for InsurAds — a Lisbon-based AI advertising technology. We help digital publishers in India achieve 30% CPM increase, 50% more viewable impressions, and 30–40% revenue growth. Zero upfront cost. Pure revenue-share model.",
  },
  {
    no: "06",
    icon: "Megaphone",
    title: "PR & Visibility Amplification",
    desc: "We extend on-ground campaigns into earned media — editorial placements, industry features, and strategic storytelling that builds brand credibility beyond physical spaces. Government liaison, GPS-verified documentation, and post-campaign reporting included.",
  },
];

export const process = [
  { no: "01", title: "Brief & Strategy", desc: "Understand objectives, audience, geography, and budget." },
  { no: "02", title: "Planning & Design", desc: "Site selection, creative direction, and fabrication design." },
  { no: "03", title: "Execution", desc: "On-ground deployment with quality checks and documentation." },
  { no: "04", title: "Monitoring", desc: "GPS-tagged verification, live reporting, and uptime tracking." },
  { no: "05", title: "Impact Report", desc: "Reach metrics, impressions, and post-campaign analysis." },
];

export const projects = [
  {
    id: "varanasi",
    category: "Infrastructure",
    tag: "Smart Infrastructure · CSR",
    title: "Varanasi Smart City Bus Shelters",
    desc: "Inaugurated by PM Narendra Modi. Solar-powered, real-time info displays, USB charging — 156 shelters across Varanasi for HUL & MakeMyTrip.",
    image: "https://images.pexels.com/photos/1661496/pexels-photo-1661496.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    featured: true,
  },
  {
    id: "raheja",
    category: "OOH",
    tag: "OOH Campaign",
    title: "Raheja Developers, Delhi",
    desc: "End-to-end bus shelter campaign at IIT Gate, Naraina, South Ext. 500K+ daily impressions per shelter.",
    image: "https://images.unsplash.com/photo-1635873432087-50eba4c4392d",
    featured: true,
  },
  {
    id: "maruti",
    category: "DOOH",
    tag: "DOOH · CSR",
    title: "Maruti Suzuki — Catch Them Young",
    desc: "Road safety program across 35 schools, reaching 5,000 students directly and 20,000 indirectly.",
    image: "https://images.pexels.com/photos/5905554/pexels-photo-5905554.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    featured: true,
  },
  {
    id: "mathura",
    category: "Infrastructure",
    tag: "Infrastructure · CSR",
    title: "MakeMyTrip — Mathura Bus Shelters",
    desc: "Custom-fabricated bus shelters with Mathura heritage aesthetic, installed under MakeMyTrip Foundation's CSR mandate.",
    image: "https://images.pexels.com/photos/8655746/pexels-photo-8655746.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    featured: false,
  },
  {
    id: "chhattisgarh",
    category: "Government",
    tag: "Government · Outdoor",
    title: "Chhattisgarh Samvad — Festival Campaigns",
    desc: "850+ outdoor boards deployed for Navratri, Rajyotsav, and Dipawali campaigns across 5 districts.",
    image: "https://images.unsplash.com/photo-1513757378314-e46255f6ed16",
    featured: false,
  },
  {
    id: "raipur",
    category: "Government",
    tag: "Government · VIP",
    title: "Nava Raipur — DGP–IG Meet 2025",
    desc: "High-visibility outdoor branding for the PM's visit and DGP-IG Meet, with GPS-verified documentation.",
    image: "https://images.unsplash.com/photo-1691480189419-b0c138c00c10",
    featured: false,
  },
  {
    id: "routes2roots",
    category: "DOOH",
    tag: "India's Largest DOOH Network · Schools",
    title: "Routes2Roots — 22,000 Screens in 20,000 Schools",
    desc: "In collaboration with the Ministry of Culture — 2 Crore children reached weekly, 60 live interactive sessions monthly, with brand advertising integration.",
    image: "https://images.unsplash.com/photo-1577896851231-70ef18881754",
    featured: false,
  },
  {
    id: "insurads",
    category: "DOOH",
    tag: "Digital Publisher · AI Tool",
    title: "InsurAds — AI Revenue Optimisation",
    desc: "Exclusive India partner. 30–40% revenue growth for digital publishers via AI-driven attention management.",
    image: "https://images.unsplash.com/photo-1707321608283-55f4d5aa7796",
    featured: false,
  },
];

export const projectFilters = ["All Projects", "OOH", "Infrastructure", "DOOH", "Government"];

export const coreValues = [
  { icon: "Target", title: "Purpose-Driven" },
  { icon: "FlaskConical", title: "Innovation-First" },
  { icon: "Building", title: "City-Scale Thinking" },
  { icon: "Handshake", title: "Partnership Model" },
  { icon: "Leaf", title: "Sustainable Design" },
];

export const founders = [
  {
    name: "Ashutosh Sharma",
    role: "Founder & Director",
    detail: "Vision, media strategy, and government partnerships.",
    phone: "+91 98992 50725",
    email: "ashutosh@oohma.in",
  },
  {
    name: "Aanya Sharma",
    role: "Co-Founder & Director",
    detail: "Strategic direction, partnerships, and brand development.",
    phone: "",
    email: "aanya@oohma.in",
  },
];

export const contactInfo = {
  phone: "+91 98992 50725",
  email: "hello@oohma.in",
  hq: "Dwarka, New Delhi, India",
  founder: "Ashutosh Sharma",
};

export const workWith = [
  "Brands & Agencies",
  "Government Bodies",
  "Media Owners",
  "Digital Publishers",
  "NGOs & CSR Teams",
];

export const enquiryTypes = [
  "Media Planning & Buying",
  "Smart Bus Shelters / Infrastructure",
  "DOOH School Network",
  "AI Publisher Solutions (InsurAds)",
  "Festival / Government Campaign",
  "Party Kahan Hai",
  "Home2Plate",
  "General Partnership",
];

export const heroImage = "https://images.pexels.com/photos/1827234/pexels-photo-1827234.jpeg";
